import { create } from 'zustand';
import type { SessionUser } from '@sundkortid/shared';

interface AuthState {
  user: SessionUser | null;
  accessToken: string | null;
  isLoading: boolean;
  setUser: (user: SessionUser | null) => void;
  setAccessToken: (token: string | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isLoading: true,
  setUser: (user) => set({ user }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setLoading: (isLoading) => set({ isLoading }),
  logout: () => set({ user: null, accessToken: null }),
}));
